"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "torraca": {
    "c20b5e60": [{
      "hkey": "546d8e5e",
      "slug": "torraca",
      "name": "Torraca",
      "primary": true,
      "skipSearch": false
    }],
    "broili": [{
      "hkey": "546d8e5e",
      "slug": "torraca",
      "name": "Torraca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5e7bccd7": [{
      "hkey": "546d8e5e",
      "slug": "torraca",
      "name": "Torraca",
      "primary": true,
      "skipSearch": false
    }],
    "coia": [{
      "hkey": "546d8e5e",
      "slug": "torraca",
      "name": "Torraca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0aa1a605": [{
      "hkey": "546d8e5e",
      "slug": "torraca",
      "name": "Torraca",
      "primary": true,
      "skipSearch": false
    }],
    "cordici": [{
      "hkey": "546d8e5e",
      "slug": "torraca",
      "name": "Torraca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "231bded0": [{
      "hkey": "546d8e5e",
      "slug": "torraca",
      "name": "Torraca",
      "primary": true,
      "skipSearch": false
    }],
    "ferrari": [{
      "hkey": "546d8e5e",
      "slug": "torraca",
      "name": "Torraca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cde215b3": [{
      "hkey": "546d8e5e",
      "slug": "torraca",
      "name": "Torraca",
      "primary": true,
      "skipSearch": false
    }],
    "lavarelli": [{
      "hkey": "546d8e5e",
      "slug": "torraca",
      "name": "Torraca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e9c2351e": [{
      "hkey": "546d8e5e",
      "slug": "torraca",
      "name": "Torraca",
      "primary": true,
      "skipSearch": false
    }],
    "nurriti": [{
      "hkey": "546d8e5e",
      "slug": "torraca",
      "name": "Torraca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6e6ecf45": [{
      "hkey": "546d8e5e",
      "slug": "torraca",
      "name": "Torraca",
      "primary": true,
      "skipSearch": false
    }],
    "pallarete": [{
      "hkey": "546d8e5e",
      "slug": "torraca",
      "name": "Torraca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "066d0cb3": [{
      "hkey": "546d8e5e",
      "slug": "torraca",
      "name": "Torraca",
      "primary": true,
      "skipSearch": false
    }],
    "san-fantino": [{
      "hkey": "546d8e5e",
      "slug": "torraca",
      "name": "Torraca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0bf1a66c": [{
      "hkey": "546d8e5e",
      "slug": "torraca",
      "name": "Torraca",
      "primary": true,
      "skipSearch": false
    }],
    "san-leonardo": [{
      "hkey": "546d8e5e",
      "slug": "torraca",
      "name": "Torraca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f0d5c78d": [{
      "hkey": "546d8e5e",
      "slug": "torraca",
      "name": "Torraca",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino": [{
      "hkey": "546d8e5e",
      "slug": "torraca",
      "name": "Torraca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5162d2f7": [{
      "hkey": "546d8e5e",
      "slug": "torraca",
      "name": "Torraca",
      "primary": true,
      "skipSearch": false
    }],
    "san-michele": [{
      "hkey": "546d8e5e",
      "slug": "torraca",
      "name": "Torraca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ce22bed5": [{
      "hkey": "546d8e5e",
      "slug": "torraca",
      "name": "Torraca",
      "primary": true,
      "skipSearch": false
    }],
    "tempe": [{
      "hkey": "546d8e5e",
      "slug": "torraca",
      "name": "Torraca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2258f389": [{
      "hkey": "546d8e5e",
      "slug": "torraca",
      "name": "Torraca",
      "primary": true,
      "skipSearch": false
    }],
    "torrette": [{
      "hkey": "546d8e5e",
      "slug": "torraca",
      "name": "Torraca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0c36403b": [{
      "hkey": "546d8e5e",
      "slug": "torraca",
      "name": "Torraca",
      "primary": true,
      "skipSearch": false
    }],
    "zaccani": [{
      "hkey": "546d8e5e",
      "slug": "torraca",
      "name": "Torraca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;